<mat-card class="info-card" [ngClass]="solution" [class.map-info-card]="isMapInfoCard">
  <mat-card-title class="title">
    @if (iconUrl) {
    <img src="{{ iconUrl }}" class="header-image" />
    } @if (!headerRouterLink) {
    <p class="card-header" [class.icon]="iconUrl">{{ this.getTitle() }}</p>
    } @else {
    <a [routerLink]="headerRouterLink">
      <p class="card-header" [class.icon]="iconUrl">{{ this.getTitle() }}</p>
    </a>
    }
  </mat-card-title>
  @if (description) {
  <mat-card-subtitle class="type-desc">{{ description }}</mat-card-subtitle>
  }

  <mat-card-content>
    <div class="content-wrapper" [style.--info-columns]="columns">
      @for (info of infoMap; track info; let i = $index) { @if (!isHidden(i)) {
      <div>
        <div [ngClass]="info.label === 'component.device' ? 'border-top width-30' : ''"></div>
        @if (info.label && info.label !== '') {
        <p [ngClass]="info.label === 'component.device' ? 'mt-xs' : ''">{{ info.label | translate }}:</p>
        }
        <div class="value-container">
          @if (info.icon) {
          <svg-icon src="{{ info.icon }}" [svgStyle]="{ 'width.px': 18, 'height.px': 18 }" class="content-image">
          </svg-icon>
          }
          <span
            [ngClass]="{
              value: true,
              line_under: info.label === 'component.project'
            }"
            (click)="info.path && info.label === 'component.project' && navigate(info.path)"
          >
            @if (!info.value2) { @if (!valueIsDate(info.value)) {
            <span class="break-word" [innerHTML]="info.value"></span>
            } @if (valueIsDate(info.value)) {
            <span class="break-word">{{ formatInfoDate(info.value) }}</span>
            } } @else {
            <span>{{ info.value }}</span>
            <span class="concrete-grey">{{ info.value2 }}</span>
            }
          </span>
        </div>
      </div>
      } }
    </div>
    @if (collapsible) {
    <button mat-button type="button" class="show-more" [attr.aria-expanded]="expanded" (click)="expanded = !expanded">
      {{ (expanded ? "SHARED.SHOW_LESS" : "SHARED.SHOW_MORE") | translate }}
    </button>
    }
  </mat-card-content>
</mat-card>
